import { IState } from '../types';
import { TAudioExercisesState, TExerciseNativeState } from './types';
import { TExerciseChoiceItem, TExerciseContent, TExerciseMatchItem } from '../../../common/rest/exercises/exercisesRest';

// compared by the translated fields only: a reload brings the same content as new objects
const translatedOf = (content: TExerciseContent) =>
	(content.items as Array<Partial<TExerciseChoiceItem & TExerciseMatchItem>>)
		.map(item => [item.question, item.explanation, item.pairs?.map(p => [p.word, p.meaning])]);

export const sameExerciseContent = (a: TExerciseContent, b: TExerciseContent): boolean =>
	a === b || (a.instruction === b.instruction && JSON.stringify(translatedOf(a)) === JSON.stringify(translatedOf(b)));

// a translation (or a request for one) is only valid for the content it was made from
export const isExerciseNativeFor = (native: TExerciseNativeState | undefined, content: TExerciseContent, langCode?: string): boolean =>
	!!native && native.langCode === langCode && sameExerciseContent(native.content, content);

export const getExerciseNatives = (state: IState): Record<number, TExerciseNativeState> => state.exercises.native;

export const getExerciseGeneratingKey = (audioId: number, promptId: number): string => `${audioId}:${promptId}`;

export const getAudioExercises = (state: IState, audioId: number): TAudioExercisesState | undefined =>
	state.exercises.byAudioId[audioId];

export const isExerciseGenerating = (state: IState, audioId: number, promptId: number): boolean =>
	!!state.exercises.generating[getExerciseGeneratingKey(audioId, promptId)];

export const isExercisesLoadFailed = (state: IState, audioId: number): boolean =>
	!!state.exercises.loadFailed[audioId];

export const isExerciseGenerateFailed = (state: IState, audioId: number, promptId: number): boolean =>
	!!state.exercises.generateFailed[getExerciseGeneratingKey(audioId, promptId)];
